// extracted by mini-css-extract-plugin
export default {"container":"UserInfoForm_container__0EhBY","formLabel":"UserInfoForm_formLabel__ecGNL"};